import {
  Box,
  Typography,
  Button,
  IconButton,
  Divider,
  Tabs,
  Tab,
  Tooltip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSetActionCall } from "../../modules/services";
import CheckIcon from "@mui/icons-material/Check";

export default function MobileExplore({
  onCustomizeClick,
  showcaseId,
  sessionId,
  mainTitle,
  modelTitle,
  productData,
}) {
  const { mutate: variantChange } = useSetActionCall();
  const productKey = productData?.[0]?.product_key;
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const colorData = useMemo(() => {
    const colorProperty = productData?.[0]?.property?.find(
      (prop) => prop.property_name.toLowerCase() === "color"
    );
    if (!colorProperty) return { variants: [], defaultVariant: null };

    const variants = colorProperty?.variants?.map((variant) => {
      const icon = variant.variant_icons.find((i) => i.file_type === "M");
      console.log("isn", variant);
      return {
        id: variant.variant_id,
        name: variant.display_name,
        image: icon?.path || "",
        isDefault: Boolean(variant.is_default),
        property_id: colorProperty.property_id,
      };
    });

    const defaultVariant =
      variants.find((v) => v.isDefault) || variants[0] || null;
    return { variants, defaultVariant };
  }, [productData]);
  console.log("productData", productData, colorData);

  const [selected, setSelected] = useState(null);
  console.log("selected", selected);
  useEffect(() => {
    if (colorData.defaultVariant) {
      setSelected(colorData.defaultVariant);
    }
  }, [colorData.defaultVariant]);

  useEffect(() => {
    if (selected && selected.id && colorData.variants.length) {
      variantChange({
        session_id: sessionId,
        message: {
          type: "change_variant",
          message: {
            product_key: productKey,
            property_id: selected.property_id,
            variant_id: selected.id,
          },
        },
      });
    }
  }, [selected, sessionId, productKey, variantChange]);

  const handleSelect = (variant) => {
    setSelected(variant);
    setOpen(false);

    if (variant.id && variant.property_id) {
      variantChange({
        session_id: sessionId,
        message: {
          type: "change_variant",
          message: {
            product_key: productKey,
            property_id: variant.property_id,
            variant_id: variant.id,
          },
        },
      });
    }
  };

  if (!colorData.variants.length) return null;

  return (
    <Box sx={{ width: "100%", bgcolor: "#fff" }}>
      {/* Car Image */}
      <Box sx={{ position: "relative", height: "35vh" }}>
        <iframe
          src={`https://canvas005.atttic.com/?showcase=${showcaseId}+&product=01+&session=${sessionId}`}
          width="100%"
          height="100%"
          frameBorder="0"
          loading="lazy"
        />
        <Box
          sx={{
            position: "absolute",
            top: 10,
            right: 20,
            display: "flex",
            gap: 1,
          }}
        >
          <IconButton size="small">
            <ViewInArIcon />
          </IconButton>
          <IconButton size="small">
            <FitScreenIcon />
          </IconButton>
        </Box>
      </Box>

      {/* Car Info */}
      <Box sx={{ p: 2 }}>
        <Box style={{ border: "1px solid grey", padding: "20px" }}>
          <Typography variant="h6" fontWeight="bold">
            {`${mainTitle} - ${modelTitle}`}
          </Typography>

          <Box
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Box>
              <Typography variant="body2">
                {`₹ 7 37 000  |  ${selected?.name}`}
              </Typography>
            </Box>

            <Box>
              <Tooltip title={selected?.name}>
                <IconButton>
                  <img
                    src={selected?.image}
                    alt={selected?.name}
                    style={{ width: 15, height: 15 }}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Color Swatches */}
          <Box sx={{ display: "flex", gap: 1, overflowX: "auto" }}>
            {colorData.variants.map((variant) => {
              const isSelected = selected?.id === variant.id;
              return (
                <Box
                  key={variant.id}
                  onClick={() => handleSelect(variant)}
                  sx={{
                    width: 36,
                    height: 36,
                    border: isSelected ? "2px solid #000" : "2px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    position: "relative",
                    backgroundColor: "#fff",
                  }}
                >
                  <Box
                    component="img"
                    src={variant.image}
                    alt={variant.name}
                    sx={{
                      width: 36,
                      height: 36,
                      objectFit: "cover",
                    }}
                  />
                  {isSelected && (
                    <CheckIcon
                      sx={{
                        fontSize: 18,
                        color: "#000",
                        position: "absolute",
                      }}
                    />
                  )}
                </Box>
              );
            })}
          </Box>

          {/* Buttons */}
          <Box mt={3}>
            {/* <Button variant="outlined" fullWidth sx={{ mb: 1 }}>
              View Highlights
            </Button> */}
            <Button
              variant="contained"
              fullWidth
              onClick={onCustomizeClick}
              sx={{
                bgcolor: "#1E45B8",
                "&:hover": { bgcolor: "#163a9d" },
              }}
            >
              Customize →
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
